/*
 *   Copyright (c) 2021 vlinder Inc.
 *   All rights reserved.
 *   This software is proprietary of vlinder Inc. and can not be distributed / used for any purpose outside of vlinder Inc. without explicit written consent from the copyright owner.
 */
//@ts-nocheck
import React from 'react';
import RenderWhen from './When';
import * as S from './ChannelPage.styles';
import {
  BannerComp,
  IBannerProps,
  ProfileComp,
  IProfileProps,
  NavItems,
  INavItemsProps,
  StatusComp,
} from './components';

export type IChannelPageWidgetProps = IBannerProps &
  IProfileProps &
  INavItemsProps;

export const ChannelPage = (props: IChannelPageWidgetProps) => {
  const {
    banner,
    text,
    profileImage,
    name,
    profileId,
    batch_1,
    batch_2,
    navBar,
    symbol,
    isNoProfileExist,
    navItems,
    profileData,
    isDetail,
  } = props;
  console.log('name bla :', props);
  return (
    <S.Container className="m-0 p-0" fluid>
      {banner && <BannerComp banner={banner} />}
      {!isNoProfileExist && isDetail && <ProfileComp {...props} />}
      <RenderWhen>
        <RenderWhen.If isTrue={Array.isArray(navItems) && navItems?.length > 0}>
          <NavItems {...props} />
        </RenderWhen.If>
      </RenderWhen>
    </S.Container>
  );
};

ChannelPage.defaultProps = {};
